import PERMISSIONS_LIST from '../../../../../../../submodules/web-shared/modules/Permissions/permissions-list';
import { portalLevelPermissions } from '../../../../../../../submodules/web-shared/modules/Permissions/PortalLevelPermissions';
import { useUserCompanies } from '../../../../../../../submodules/web-shared/reducers/user-companies/hooks';
import { COMPANY_SETTING_NAME } from '../../../../companies/api/company-settings/enums/company-settings';

const useEmbeddedReportsAccess = () => {
  const { isCompanySettingEnabled } = useUserCompanies();

  const hasEmbeddedReportsAccess = () => {
    return isCompanySettingEnabled(COMPANY_SETTING_NAME.EMBEDDED_REPORTS_ACCESS)
      && portalLevelPermissions.isPermissionEnabled(PERMISSIONS_LIST.view_power_bi_reports, null);
  };

  return {
    hasEmbeddedReportsAccess,
  };

};

export default useEmbeddedReportsAccess;